import Grid from '@material-ui/core/Grid';
import { CardContent, Divider, Toolbar, FormControl, RadioGroup, FormControlLabel, Radio, Button } from '@material-ui/core';
import React from 'react';
import Card from '@material-ui/core/Card';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import CollectionItemHeader from '../../layout/CollectionItemHeader';
import AppButtonMinimal from '../../basic/AppButtonMinimal';
import { useItem } from '../../../hooks/atoms/item-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';
import AppLoader from '../../basic/AppLoader';
import BasicField from '../../basic/BasicField';
import getTheme from '../../../theme/theme';
import { useDialog } from '../../../dialog-provider-hooks';

const DoctorDetails = ({
  id,
}) => {
  const {
    item: doctor,
    itemIsLoading,
    itemError,
    updateItem: updateDoctor,
  } = useItem(CollectionKeys.DOCTORS, id);

  const { openDialog } = useDialog();

  const openVerifyDoctorDialog = (action) => {
    openDialog({
      title: action === 'VERIFIED' ? 'Verify doctor ?' : (action === 'UNVERIFIED' ? 'Disclaim doctor ?' : 'Block doctor ?'),
      body() {
        return (
          <>
            <p>{`Are you sure you want to ${ action === 'VERIFIED' ? 'verify' : (action === 'UNVERIFIED' ? 'disclaim' : 'block') } ${ doctor.name } ${ doctor.family_name }`}</p>
          </>
        );
      },
      onSubmit() {
        return updateDoctor({ verification_status: action });
      },
    });
  };

  const updateDoctorType = (type) => {
    return updateDoctor({ idna_company: type });
  };

  if (itemIsLoading) {
    return <AppLoader />;
  }

  if (itemError) {
    return <p>Error</p>;
  }

  return (
    <>
      <CollectionItemHeader
        title={ `${ doctor.name } ${ doctor.family_name }` }
        subtitle={ `Created at: ${ doctor.created_at }` }
        // actions={ (
        //   <>
        //     <div />
        //     <Grid container spacing={ 1 } justify='flex-end'>
        //       <Grid item>
        //         <AppButtonMinimal
        //           text='Reset password'
        //           color={ getTheme().palette.warning.main }
        //           onClick={ () => { } }
        //         />
        //       </Grid>
        //       <Grid item>
        //         <AppButtonMinimal
        //           text='Block'
        //           color={ getTheme().palette.error.main }
        //           onClick={ () => { } }
        //         />
        //       </Grid>
        //     </Grid>
        //   </>
        // ) }
      />
      <Toolbar />
      <Grid container spacing={ 3 }>
        <Grid container item xs={ 12 } spacing={ 3 }>
          <Grid item xs={ 4 }>
            <Card>
              <CardContent>
                <Grid item xs={ 12 }>
                  <BasicField
                    disabled
                    title='Specialty'
                    field={ doctor.specialty }
                  />
                  <BasicField
                    disabled
                    title='E-mail'
                    field={ doctor.email }
                  />
                  <BasicField
                    disabled
                    title='Business number'
                    field={ doctor.business_number }
                  />

                  <BasicField
                    disabled
                    title='Business number'
                    field={ doctor.business_number }
                  />

                  <FormControl required>
                    <RadioGroup
                      onChange={ (e) => { updateDoctorType(e.target.value); } }
                      style={ { display: 'flex', flexDirection: 'row', gap: '20px' } }
                      defaultValue={ doctor?.idna_company }
                    >
                      <FormControlLabel
                        value='Genomics'
                        control={ <Radio /> }
                        label='Genomics'
                      />
                      <FormControlLabel
                        value='Laboratories'
                        control={ <Radio /> }
                        label='Laboratories'
                      />
                    </RadioGroup>
                  </FormControl>

                  <Button />

                  <Grid item>
                    <Divider style={ { margin: getTheme().spacing(1, 0) } } />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={ 8 }>
            {'VERIFIED' === doctor.verification_status ? (
              <Grid container spacing={ 2 }>
                <Grid item xs={ 12 }>
                  <Alert severity='success'>
                    <AlertTitle>Verified</AlertTitle>
                  </Alert>
                </Grid>
                <Grid item>
                  <AppButtonMinimal
                    text='Disclaim doctor'
                    color={ getTheme().palette.error.main }
                    onClick={ () => { openVerifyDoctorDialog('UNVERIFIED'); } }
                  />
                </Grid>
                <Grid item>
                  <AppButtonMinimal
                    text='Block doctor'
                    color={ getTheme().palette.error.main }
                    onClick={ () => { openVerifyDoctorDialog('BLOCKED'); } }
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={ 2 }>
                <Grid item xs={ 12 }>
                  <Alert severity={ 'UNVERIFIED' === doctor.verification_status ? 'warning' : 'error' }>
                    <AlertTitle>{'UNVERIFIED' === doctor.verification_status ? 'Not verified' : 'Blocked'}</AlertTitle>
                    {`User is ${ 'UNVERIFIED' === doctor.verification_status ? 'not verified' : 'blocked' }. You need to verify the doctor in order to give him/her access to the EMR`}
                  </Alert>
                </Grid>
                <Grid item>
                  <AppButtonMinimal
                    disabled={ doctor.idna_company == null }
                    tooltip={ doctor.idna_company == null ? 'You need to select an iDNA company' : '' }
                    text='Verify doctor'
                    color={ getTheme().palette.info.main }
                    onClick={ () => { openVerifyDoctorDialog('VERIFIED'); } }
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default DoctorDetails;
